export const HELP_CASE_TYPES = {
  HELP: 'Portal - help',
  CONTACT_US: null,
  FUNDING_UNSURE: 'Funding - Unsure/other',
  ENVIRONMENTAL_SAT: 'Environmental self-assessment'
}

export const CASE_TYPES = {
  SAVING_FAILED: 'Saving Failed',
  DOP: ' Inquiry for DoP'
}
